// @flow

// Prevent Chrome from holding on button focus after a click event on a button
const worker = (event: MouseEvent) => {
    if (event.target instanceof HTMLButtonElement) {
        const button = event.target;
        if (button.matches("button")) {
            button.blur();
        }
    }
};

window.addEventListener("mouseup", worker);
window.addEventListener("touchend", worker);
